<script setup>
import { Link } from '@inertiajs/vue3';
import { onMounted, ref, nextTick } from 'vue';
import App from '@/Layouts/App.vue';
import imageHelper from '@/Helpers/image_helper.js';

const { getImage } = imageHelper.methods;

const props = defineProps({
    contactUs: Array,
    contactDetail: Array
});

const descriptionContainers = ref([]);

onMounted(async () => {
    await nextTick();

    descriptionContainers.value.forEach((container) => {
        if (container) {
            const links = container.querySelectorAll('a');
            links.forEach((link) => {
                const href = link.getAttribute('href');

                if (href) {
                    if (href.startsWith('http')) {
                        link.setAttribute('target', '_blank');
                        link.setAttribute('rel', 'noopener noreferrer');
                    } else if (href.startsWith('mailto:') || href.startsWith('tel:')) {
                        link.removeAttribute('target');
                        link.removeAttribute('rel');
                    }
                }
            });
        }
    });
});
</script>

<template>
    <App :isShowContactUs="true">
        <template v-for="item in contactUs" :key="item.id">
            <section class="relative bg-cover bg-center w-full height-banners"
                :style="{ backgroundImage: `url(${getImage(item.image_banner)})` }">
                <div class="absolute top-0 w-full h-full flex flex-col justify-center items-center gap-y-1 p-3 md:p-0">
                    <h1 class="text-title text-primaryColor text-center">{{ item.title }}</h1>
                    <p class="text-description text-grayBlackColor text-center width-description-banner">
                        {{ item.description }}
                    </p>
                </div>
            </section>
        </template>

        <section class="content-body py-5 md:py-10 content-padding">
            <div class="grid grid-cols-1 md:grid-cols-3 gap-3 xl:gap-5">
                <template v-for="(item, index) in contactDetail" :key="index">
                    <div
                        class="w-full h-full flex justify-start md:justify-center items-center gap-x-3 md:gap-x-5 p-4 bg-grayWhiteColor border border-primaryColor/10">
                        <img class="h-8 md:h-10" :src="getImage(item.image_thumbnail)" alt="Icons Contact us">
                        <div class="flex flex-col justify-start gap-y-0 md:gap-y-0">
                            <h2 class="text-secondary md:text-tertiary font-bold">{{ item.title }}</h2>
                            <a class="text-description hover:text-primaryColor"
                                v-html="item.description"
                                ref="descriptionContainers">
                            </a>
                        </div>
                    </div>
                </template>
            </div>
        </section>
    </App>
</template>
